import React from 'react';
import Icon from '../../../components/AppIcon';

const ExperimentStats = ({ stats }) => {
  const statItems = [
    {
      label: 'Total Experiments',
      value: stats?.totalExperiments,
      icon: 'Beaker',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Active Projects',
      value: stats?.activeProjects,
      icon: 'Activity',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Community Votes',
      value: stats?.communityVotes,
      icon: 'Heart',
      color: 'text-cosmic-energy',
      bgColor: 'bg-cosmic-energy/10'
    },
    {
      label: 'Code Views',
      value: stats?.codeViews,
      icon: 'Eye',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="glass-panel rounded-lg p-4 hover:cosmic-glow-hover transition-all duration-300"
        >
          <div className="flex items-center space-x-3">
            <div className={`w-10 h-10 rounded-lg ${item?.bgColor} flex items-center justify-center`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
            <div>
              <div className={`text-2xl font-headline font-bold ${item?.color}`}>
                {item?.value}
              </div>
              <div className="text-xs text-muted-foreground font-body">
                {item?.label}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExperimentStats;